module.exports = __webpack_public_path__ + "static/img/icon_axmj.2f482a16.png";